import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import cns from 'classnames';
import log from '../../../utils/log';
import WithTranslation from '../../../hocs/WithTranslation';

class TextInput extends PureComponent {
    // constructor(props) {
    //   super(props);
    // }

    static propTypes = {
        placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        onChange: PropTypes.func,
        onBlur: PropTypes.func,
        disabled: PropTypes.bool,
        required: PropTypes.bool,
        type: PropTypes.oneOf(['text', 'email', 'password', 'number']),
        componentClass: PropTypes.string,
        maxLength: PropTypes.string,
        name: PropTypes.string,
        rows: PropTypes.number,
        input: PropTypes.string,
        className: PropTypes.string,
        styleProps: PropTypes.object,
        onKeyDown: PropTypes.func,
        autoFocus: PropTypes.bool
    };

    render() {
        const {
            value = '',
            disabled = false,
            required = false,
            type = 'text',
            input,
            className = '',
            styleProps = {},
            onKeyDown,
            onBlur = () => {},
            autoFocus = false
        } = this.props;
        if (input) {
            log.error('Input property is being passed into the TextInput.  This functionality has been deprecated.');
        }
        return (
            <div className={cns(className)}>
                <Form.Control
                    as={this.props.componentClass}
                    onChange={this.props.onChange}
                    value={value}
                    disabled={disabled}
                    required={required}
                    placeholder={this.props.placeholder}
                    rows={this.props.rows}
                    type={type}
                    maxLength={this.props.maxLength}
                    name={this.props.name}
                    className={cns(styleProps)}
                    onKeyDown={onKeyDown}
                    onBlur={onBlur}
                    autoFocus={autoFocus}
                />
            </div>
        );
    }
}

export default WithTranslation(TextInput);
